<!--<div class="page-wrapper">-->
<!--&lt;!&ndash;  <app-pop-up-alert *ngIf="contactForm && this.submitPage || addressForm && this.submitPage"></app-pop-up-alert>&ndash;&gt;-->
<!--</div>-->

<div class="page-wrapper h-100 w-100">
  <router-outlet></router-outlet>
</div>
